import React, { useState, useEffect } from 'react';

import Globals, { URLS } from '../../../utility/constants/appConstants';
import { amountFormatter } from '../../../utility/utils/formatter';

import { calculateLastPayment } from '../../../utility/features/helpers/accountHelper';
import Storage from '../../../utility/features/helpers/storageHelper';
import { Link } from 'react-router';

const EasyPayLastpayment = (props) => {
    const [amount, setAmount] = useState(0);
    const [invoiceDate, setInvoiceDate] = useState('N/A');
    const [queryString, setQueryString] = useState(window.location.search != ""?window.location.search:"");

    const {paymentsCss, isActionEnabled} = props;

    useEffect(() => {
        setInvoiceDate(props.noDate);

        if (props.serviceAgreement.Invoices) {
            const { amount, invoiceDate } = calculateLastPayment(props.serviceAgreement.Invoices);
            setAmount(amount);
            setInvoiceDate(invoiceDate);
        }
    }, []);

    const { enrolled, lastPayDate, payEndText, updateEPPref, amountDue} = props.labels;
    const { autoChgAcctRef } = props.serviceAgreement;
    const { dollars, cents } = amountFormatter(amount);

    return (
      <>
        <div className={`${paymentsCss["bg-white"]} col-12 col-md-4 col-lg-3 d-flex flex-column justify-content-end text-center text-lg-left p-0 ${paymentsCss["tru-mma-main-side"]}`}>
          <div className={`align-items-center d-flex flex-column flex-fill justify-content-center ${paymentsCss["p-10"]}`}>
            <span className={`d-block ${paymentsCss["gfs-lg-16"]} ${paymentsCss["gfs-14"]} ${paymentsCss['gfw-3']} `}>{enrolled}</span>
            <span className={`d-block ${paymentsCss["gfs-10"]} ${paymentsCss["gfs-lg-14"]}`}> { amount<=0 ? amountDue : lastPayDate} </span>
            <span className={`d-block ${paymentsCss["gfs-50"]} ${paymentsCss["gfs-md-26"]} ${paymentsCss["gfw-7"]}`}>
              <span>
                {Globals.currencySymbol}{dollars}
              </span>
              <sup className={`${paymentsCss["gfs-26"]} ${paymentsCss["gfs-md-16"]} margin-left`}>
                {cents}
              </sup>
            </span>
            <span className={`d-block ${paymentsCss["gfs-10"]} ${paymentsCss["gfs-lg-14"]} text-center w-100`}>
              {payEndText}{autoChgAcctRef.slice(-4)}
            </span>
          </div>
          <Link to={isActionEnabled?URLS.easyPayPrefernces+queryString:""} onClick={() => {
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                    'event' : 'account_action',
                    'category': 'Account',
                    'action': 'account summary',
                    'label': 'update payment preferences',
                    'customer_id': (Storage.customerNumber() || {}),
                    'error' : {
                        'reason' : '',                
                    }
                })
            }}
            className={`ShowLoadingModal ${paymentsCss["bg-green"]} ${paymentsCss["gfs-20"]} gfs-md-10 ${paymentsCss["gfs-lg-14"]} text-center ${paymentsCss["tru-mma-main-side-update"]} text anchor ${!isActionEnabled ? 'opacity-50 pe-none' : ''}`}>
            {updateEPPref}
          </Link>
        </div>
      </>
    );
}

export default EasyPayLastpayment;